import axios from 'axios';

import { ROOT_URL_V2, getCSRFToken } from '../config';
import { TAgent } from '../types';

export const LOAD_AGENTS_FOR_AGENCY = 'LOAD_AGENTS_FOR_AGENCY';
export const LOAD_AGENTS_FOR_AGENCY_SUCCESS = 'LOAD_AGENTS_FOR_AGENCY_SUCCESS';
export const LOAD_AGENTS_FOR_AGENCY_FAILURE = 'LOAD_AGENTS_FOR_AGENCY_FAILURE';

type TError = unknown;

type TloadAgentsAction = {
    type: typeof LOAD_AGENTS_FOR_AGENCY;
};

type TloadAgentsSuccessAction = {
    type: typeof LOAD_AGENTS_FOR_AGENCY_SUCCESS;
    payload: TAgent[];
};

type TloadAgentsFailure = {
    type: typeof LOAD_AGENTS_FOR_AGENCY_FAILURE;
    payload: TError;
};

export type TAgentsActions =
    | TloadAgentsAction
    | TloadAgentsSuccessAction
    | TloadAgentsFailure;

export const loadAgents = (): TloadAgentsAction => ({
    type: LOAD_AGENTS_FOR_AGENCY,
});

export const loadAgentsSuccess = (
    data: TAgent[],
): TloadAgentsSuccessAction => ({
    type: LOAD_AGENTS_FOR_AGENCY_SUCCESS,
    payload: data,
});

export const loadAgentsFailure = (error: TError): TloadAgentsFailure => ({
    type: LOAD_AGENTS_FOR_AGENCY_FAILURE,
    payload: error,
});

export function loadAgentsforAgency(agencyId: number) {
    return async(dispatch: any) => {
        dispatch(loadAgents());

        let agentsResult: TAgent[];

        try {
            const response = await axios({
                method: 'GET',
                url: `${ROOT_URL_V2}agencies/${agencyId}/agents/`,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
            });
            agentsResult = response.data.content;
        } catch (error) {
            dispatch(loadAgentsFailure(error));
            return;
        }

        dispatch(loadAgentsSuccess(agentsResult));
    };
}
